export default require('./Poster').default
